import "../base.js";
import "../../models/base.js";
import "../../../../shared/events.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

AppointmentBooking.Wizard.Views.NavigationButton = class NavigationButton extends AppointmentBooking.Wizard.Views.Base {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.triggerButtonAction = this.triggerButtonAction.bind(this);
    this.updateEnabledState = this.updateEnabledState.bind(this);
    this.updateText = this.updateText.bind(this);
    this.setText = this.setText.bind(this);
    this.enable = this.enable.bind(this);
    this.disable = this.disable.bind(this);
    this.hold = this.hold.bind(this);
    this.resume = this.resume.bind(this);
    this.toggle = this.toggle.bind(this);
    this.isEnabled = this.isEnabled.bind(this);
    this.setEnabledState = this.setEnabledState.bind(this);
    this.setDisabledState = this.setDisabledState.bind(this);
    this.triggerButtonClicked = this.triggerButtonClicked.bind(this);
    this.triggerDisabledButtonClicked = this.triggerDisabledButtonClicked.bind(this);
  }

  initialize(attributes = {}) {
    this.model = new AppointmentBooking.Wizard.Models.Base(attributes);
    this.$el.attr({
      "data-button-name": attributes.name,
      "data-testid": this.testIds()?.booking?.[attributes.name],
      role: "button",
    });

    this.listenTo(this.model, "change:enabled", this.updateEnabledState);
    return this.listenTo(this.model, "change:text", this.updateText);
  }

  // EVENT HANDLERS

  handleButtonClick() {
    return this.triggerButtonAction();
  }

  triggerButtonAction() {
    if (this.model.get("held")) {
      return this.model.set("clickedWhileHeld", true);
    } else if (this.model.get("enabled")) {
      return this.triggerButtonClicked(this.model.get("name"));
    } else {
      return this.triggerDisabledButtonClicked(this.model.get("name"));
    }
  }

  // RENDERING

  updateEnabledState() {
    if (this.model.get("enabled")) {
      return this.setEnabledState();
    } else {
      return this.setDisabledState();
    }
  }

  updateText() {
    return this.$(".navigation-button-label").text(this.model.get("text"));
  }

  // DSL

  setText(text) {
    return this.model.set("text", text);
  }

  enable() {
    return this.model.set("enabled", true);
  }

  disable() {
    return this.model.set("enabled", false);
  }

  hold() {
    return this.model.set("held", true);
  }

  resume(state = true) {
    const clickedWhileHeld = this.model.get("clickedWhileHeld");
    this.model.set({ held: false, clickedWhileHeld: false });
    this.toggle(state);
    if (this.isEnabled() && clickedWhileHeld) {
      return this.triggerButtonClicked();
    }
  }

  toggle(state) {
    return this.model.set("enabled", state);
  }

  isEnabled() {
    return this.model.get("enabled");
  }

  // PRIVATE

  setEnabledState() {
    this.$el.attr("tabIndex", 0);
    this.$el.toggleClass("enabled", true);
    return this.$el.toggleClass("disabled", false);
  }

  setDisabledState() {
    this.$el.attr("tabIndex", -1);
    this.$el.toggleClass("enabled", false);
    return this.$el.toggleClass("disabled", true);
  }

  triggerButtonClicked() {
    const event = AppointmentBooking.Wizard.Events.Navigation[`${this.model.get("name")}ButtonClicked`];
    if (event) {
      return this.triggerEvent(event);
    }
  }

  triggerDisabledButtonClicked() {
    const event = AppointmentBooking.Wizard.Events.Navigation[`${this.model.get("name")}ButtonClickedWhileDisabled`];
    if (event) {
      return this.triggerEvent(event);
    }
  }
};
AppointmentBooking.Wizard.Views.NavigationButton.prototype.template = "navigation/navigation_button";
AppointmentBooking.Wizard.Views.NavigationButton.prototype.className = "appointment-booking-wizard-navigation-button";
AppointmentBooking.Wizard.Views.NavigationButton.prototype.events = { click: "handleButtonClick" };
